var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00A32E",
  d: "M14.333 11.25H2.5V9.583h11.833L11.75 7l1.167-1.167 4.583 4.584L12.917 15l-1.167-1.167z"
})));
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjMzMzMgMTEuMjVMMi41IDExLjI1TDIuNSA5LjU4MzMzTDE0LjMzMzMgOS41ODMzM0wxMS43NSA3TDEyLjkxNjcgNS44MzMzM0wxNy41IDEwLjQxNjdMMTIuOTE2NyAxNUwxMS43NSAxMy44MzMzTDE0LjMzMzMgMTEuMjVaIiBmaWxsPSIjMDBBMzJFIi8+Cjwvc3ZnPgo=";